import { backendApi } from 'api/api';
import APIErrorsHandlingUtils from 'utils/APIErrorsHandlingUtils';

const formatResult = (data) => {
  if (!data) return { data: [], meta: null };
  if (Array.isArray(data)) return { data, meta: null };
  if (Array.isArray(data.data)) return { data: data.data, meta: data.meta ?? null };
  return { data: [], meta: null };
};

export default class EphanService {
  static async getDancers(params) {
    const [error, data] = await backendApi.get('/ephan/dancers', { params });

    if (error) {
      return { result: null, error: APIErrorsHandlingUtils.handleErrors(error) };
    }

    return { result: formatResult(data), error: null };
  }

  static async getJudges(params) {
    const [error, data] = await backendApi.get('/ephan/judges', { params });

    if (error) {
      return { result: null, error: APIErrorsHandlingUtils.handleErrors(error) };
    }

    return { result: formatResult(data), error: null };
  }

  static async getCoaches(params) {
    const [error, data] = await backendApi.get('/ephan/coaches', { params });

    if (error) {
      return { result: null, error: APIErrorsHandlingUtils.handleErrors(error) };
    }

    return { result: formatResult(data), error: null };
  }

  static async getClubs(params) {
    const [error, data] = await backendApi.get('/ephan/clubs', { params });

    if (error) {
      return { result: null, error: APIErrorsHandlingUtils.handleErrors(error) };
    }

    return { result: formatResult(data), error: null };
  }

  static async getRegistryFilters() {
    const [error, data] = await backendApi.get('/ephan/registry-filters');

    if (error) {
      return { result: null, error: APIErrorsHandlingUtils.handleErrors(error) };
    }

    return { result: data?.data ?? data ?? null, error: null };
  }

  // Compatibility stubs for legacy actions so callers won't break if dispatched
  static async getStatuses() {
    return { result: {}, error: null };
  }

  static async getDancerClasses() {
    return { result: {}, error: null };
  }

  static async getCountries() {
    return { result: {}, error: null };
  }
}
